'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { withRouter } from 'react-router-dom';
export default (Component => // eslint-disable-next-line no-unused-vars
withRouter((_ref) => {
  let {
    routes = []
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["location", "params", "router", "routes"]);

  const lastRoute = routes.slice().reverse().find(route => route.name);
  return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
    screen: lastRoute ? lastRoute.name : ''
  }));
}));